import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const AiMetricsPage = lazy(() =>
  import('../../pages/admin/ai-metrics/AiMetricsPage').then((m) => ({
    default: m.AiMetricsPage,
  })),
);

export const Route = createFileRoute('/admin/ai-metrics')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <AiMetricsPage />
    </Suspense>
  ),
});
